import { createFileRoute } from '@tanstack/react-router'
import React from "react";
import Master_PostsView from "../../../master/PostsView.tsx";

export const Route = createFileRoute('/_app/master/posts/$post_uid')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Master_PostsView />
}
